export const ZENDESK_SCRIPT_URL = `https://static.zdassets.com/ekr/snippet.js`;
export const DEFAULT_DEPARTMENTS_LIST = [
  'Bonus issues 21bit', 'Deposit Assistance 21bit', 'Extra bonus 21bit', 'High Roller promotions 21bit',
  'Other issues 21bit', 'Reopen account 21bit', 'Technical issue 21bit', 'Verification process 21bit', 'Withdrawal 21bit'
];
export const ONLINE_CHAT_COUNTRIES = ['au', 'de', 'ca', 'nz', 'fi', 'at', 'dk', 'ie', 'jp', 'it', 'br'];

export const zendeskStag = '84397';

export interface IZendeskUserData {
  name?: string;
  email?: string;
}
